<div class="success-msg-container" *ngIf="showSuccessGrowl">
  <div *ngIf="isSuccess" class="success">
    <i class="pi pi-check-circle"></i> <span>Reset password link has been send to email {{ successMail }}</span>
  </div>
  <div *ngIf="!isSuccess" class="failed">
    <span>Account Not Found!</span>
  </div>
</div>

<div id="turnstileWidget"></div>

<div *ngIf="!isLoadingPage" class="login" [ngStyle]="{'background-image': 'url(' + pattern + ')'}">
  <div id="login-page-id" class="login-page">
    <div id-="form-container-id" class="form-container">
      <div class="login-form-container">
        <div class="campus-input-button">
          <div class="campus-container">
            <div>
              <div class="img-cnt">
                <div class="logo-cnt"><img class="iamneo-icon" [src]="logo" alt="LOGO" /></div>
                <span class="title">{{schoolName || 'Neo PAT'}}</span>
              </div>
            </div>
            <div class="login-top-bar">
              <h1> {{ subTitleMessages[currentTab].title }} </h1>
              <p> {{ subTitleMessages[currentTab].subTitle }} </p> 
            </div>
            <ng-container *ngIf="currentTab === 'login'">
              <form id="mail-form-id" [formGroup]="loginForm" class="email-password-cant">
                <div class="input-container">
                  <div style="position: relative;">
                    <span id="mail-span-id" class="p-float-label email-cant">
                      <input formControlName="email" [required]="true" [attr.disabled]="isEmailEntered ? true :undefined"
                        class="email-input-with-image-login" (keyup.enter)="getAccountDataWithEmail()" [ngClass]="{
                                              'p-filled': loginForm.value.email,
                                              'dirty-input':
                                                (!loginForm.get('email')?.valid &&
                                                  loginForm.get('email')?.touched) ||
                                                invalidCred
                                            }" style="min-width: 100% !important" type="email" id="mail-input-id" pInputText
                        (click)="invalidCred = false" />
                      <label for="inputtext" [ngClass]="[
                                              !loginForm.get('email')?.valid &&
                                              loginForm.get('email')?.touched
                                                ? 'touched-email'
                                                : invalidCred
                                                ? 'invalid-credentials'
                                                : ''
                                            ]">Email
                      </label>
                    </span>
                    <span class="change-txt" *ngIf="isEmailEntered" (click)="resetEmailEntered()" (keydown)="resetEmailEntered()">
                      Change
                    </span>
                  </div>
                  <div class="error-msg-container">
                    <div id="mail-err-msg-1" *ngIf="loginForm.get('email')?.hasError('pattern')"
                      class="error-msg error-msg-cant">
                      <span [ngClass]="[
                        !loginForm.get('email')?.valid &&
                        loginForm.get('email')?.touched &&
                        loginForm.get('email')?.dirty
                          ? 'visible-element'
                          : 'hidden-element'
                      ]">
                        Enter a valid Email ID
                      </span>
                    </div>
                    <div id="mail-err-msg-2" class="error-msg" *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.errors">
                      <p *ngIf="loginForm.get('email')?.errors?.['required']">
                        Email is required
                      </p>
                    </div>
                    <div id="password-err-msg" *ngIf="invalidCred" class="error-msg error-msg-cant">
                      <span *ngIf="!isEmailEntered" [ngClass]="[invalidCred ? 'visible-element' : 'hidden-element']">
                        {{ errorMessage }}
                      </span>
                    </div>
                  </div>
                </div>
                <ng-container *ngIf="isEmailEntered">
                    <div class="input-container">
                      <span id="password-span-id" class="p-float-label email-cant">
                        <input formControlName="password" [required]="true" class="password-input-with-image passwordInput" [ngClass]="{
                                                'p-filled': loginForm.value.password,
                                                'dirty-input':
                                                  (!loginForm.get('password')?.valid &&
                                                    loginForm.get('password')?.touched) ||
                                                  invalidCred
                                              }" style="min-width: 100% !important" [attr.type]="showPassword ? 'text':'password'" id="mail-input-id" pInputText
                          (click)="invalidCred = false" (keyup.enter)="signIn()" />
                        <label for="inputtext" [ngClass]="[
                                              !loginForm.get('password')?.value &&
                                              loginForm.get('password')?.touched
                                                ? 'touched-password'
                                                : invalidCred 
                                                ? 'invalid-credentials'
                                                : ''
                                            ]">Password
                        </label>
                      </span>
                      <div class="error-msg-container">
                        <div id="password-err-msg" *ngIf="
                                                        !loginForm.get('password')?.valid &&
                                                        loginForm.get('password')?.touched
                                                      " class="error-msg error-msg-cant">
                          <span [ngClass]="[
                                                          !loginForm.get('password')?.valid &&
                                                          loginForm.get('password')?.touched
                                                            ? 'visible-element'
                                                            : 'hidden-element'
                                                        ]">Password is required</span>
                        </div>
                        <div id="password-err-msg" *ngIf="invalidCred" class="error-msg error-msg-cant">
                          <span [ngClass]="[invalidCred ? 'visible-element' : 'hidden-element']">
                            {{ errorMessage }}
                          </span>
                        </div>
                      </div>
                      <div *ngIf="isEmailEntered" class="show_forgot_password_container">
                        <div class="item-center">
                          <div class="item-center">
                            <p-checkbox [binary]="true" (onChange)="showAction()">
                            </p-checkbox>
                          </div>
                          <div class="show-password">Show Password</div>
                        </div>
                        <span id="checkbox-forgot-id" class="checkbox-forgot-password"
                        (click)="switchTab('reset')" (keydown)="switchTab('reset')">Forgot Password?</span>
                      </div>
                    </div>
                </ng-container>
                <span id="sign-in-id" *ngIf="isEmailEntered" class="btn-actions" [ngClass]="[
                                                          loginForm.valid ? 'enable-signin' : 'disable-signin'
                                                        ]" type="submit" (click)="signIn()">
                  <span *ngIf="!isLoading">Sign in</span>
                  <span class="sign-btn-load" *ngIf="isLoading">
                    <p-progressSpinner class="signin-spinner" [style]="{ height: '20px', width: '20px' }" strokeWidth="7"
                      animationDuration="0.5s">
                    </p-progressSpinner>
                  </span>
                </span>
                <span id="sign-in-id" class="btn-actions" [ngClass]="[ loginForm.valid ? 'enable-signin' : 'disable-signin']"
                  type="submit" *ngIf="!isEmailEntered" (click)="getAccountDataWithEmail()">
                  <span *ngIf="!isLoading">Continue</span>
                  <span class="sign-btn-load" *ngIf="isLoading">
                    <p-progressSpinner class="signin-spinner" [style]="{ height: '20px', width: '20px' }" strokeWidth="7"
                      animationDuration="0.5s">
                    </p-progressSpinner>
                  </span>
                </span>
              </form>
            </ng-container>
            <ng-container *ngIf="currentTab === 'reset'">
              <form id="mail-form-id" [formGroup]="loginForm" class="email-password-cant">
                <div class="input-container">
                  <span id="mail-span-id" class="p-float-label email-cant">
                    <input formControlName="email" [required]="true" class="email-input-with-image" [ngClass]="{
                          'p-filled': loginForm.value.email,
                          'dirty-input':
                            (!loginForm.get('email')?.valid &&
                              loginForm.get('email')?.touched) ||
                            invalidCred
                        }" type="email" id="mail-input-id" (input)="showSuccessGrowl = false" pInputText style="min-width: 100% !important"
                      (click)="invalidCred = false" />
                    <label for="inputtext" [ngClass]="[
                          !loginForm.get('email')?.valid &&
                          loginForm.get('email')?.touched
                            ? 'touched-email'
                            : invalidCred
                            ? 'invalid-credentials'
                            : ''
                        ]">Email
                    </label>
                  </span>
                  <div class="error-msg-container">
                    <div id="mail-err-msg-1" *ngIf="loginForm.get('email')?.hasError('pattern')"
                      class="error-msg error-msg-cant">
                      <span [ngClass]="[
                        !loginForm.get('email')?.valid &&
                        loginForm.get('email')?.touched &&
                        loginForm.get('email')?.dirty
                          ? 'visible-element'
                          : 'hidden-element'
                      ]">
                        Enter a valid Email ID
                      </span>
                    </div>
                    <div id="mail-err-msg-2" class="error-msg" *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.errors">
                      <p *ngIf="loginForm.get('email')?.errors?.['required']">
                        Email is required
                      </p>
                    </div>
                  </div>
                </div>
                <span id="sign-in-id" class="btn-actions" [ngClass]="[
                      loginForm.valid ? 'enable-signin' : 'disable-signin'
                    ]" type="submit" (click)="resetPassword()">
                  <span *ngIf="!isLoading">Reset Password</span>
                  <span class="sign-btn-load" *ngIf="isLoading">
                    <p-progressSpinner class="signin-spinner" [style]="{ height: '20px', width: '20px' }" strokeWidth="7"
                      animationDuration="0.5s">
                    </p-progressSpinner>
                  </span>
                </span>
                <div class="content-center">
                  <span class="forgot-password" (click)="switchTab('login')"> 
                    Back to Sign in
                  </span>
                </div>
              </form>
            </ng-container>
            <ng-container *ngIf="currentTab === 'change'">
              <form  [formGroup]="loginForm" class="email-password-cant" autocomplete="off">
                <div class="input-container">
                  <span id="mail-span-id" class="p-float-label email-cant">
                    <input
                      id="user-email" 
                      formControlName="email" 
                      [required]="true" 
                      class="email-input-with-image p-filled"
                      style="min-width: 100% !important" 
                      type="email" 
                      pInputText
                    />
                    <label for="inputtext" [ngClass]="[
                          !loginForm.get('email')?.valid &&
                          loginForm.get('email')?.touched
                            ? 'touched-email'
                            : invalidCred
                            ? 'invalid-credentials'
                            : ''
                        ]">Email
                    </label>
                  </span>
                </div>
                <div class="input-container">
                  <span id="password-span-id" class="p-float-label password-cant">
                    <p-password 
                        autocomplete="off"
                        class="password-input-with-image passwordInput" 
                        formControlName="newPassword" 
                        [toggleMask]="true" 
                        [required]="true"
                        [feedback]="true"
                        id="password-input-id"
                        (click)="invalidCred = false"
                        [ngClass]="{
                            'p-filled': loginForm.value.password,
                            'dirty-input':
                            (!loginForm.get('password')?.valid &&
                            loginForm.get('password')?.touched) ||
                            invalidCred
                        }">
                    </p-password>
  
                    <label for="inputtext" [ngClass]="[
                          !loginForm.get('password')?.value &&
                          loginForm.get('password')?.touched
                            ? 'touched-password'
                            : invalidCred 
                            ? 'invalid-credentials'
                            : ''
                        ]">New Password
                    </label>
                  </span>
                </div>
                <div class="input-container">
                  <span id="password-span-id" class="p-float-label password-cant">
                    <p-password 
                      autocomplete="off"
                      class="password-input-with-image passwordInput" 
                      formControlName="confirmPassword" 
                      [toggleMask]="true" 
                      [required]="true"
                      [feedback]="false"
                      id="password-input-id"
                      (click)="invalidCred = false"
                      [ngClass]="{
                        'p-filled': loginForm.value.password,
                        'dirty-input':
                          (!loginForm.get('password')?.valid &&
                            loginForm.get('password')?.touched) ||
                          invalidCred
                      }">
                    </p-password>
  
                    <label for="inputtext" [ngClass]="[
                          !loginForm.get('password')?.value &&
                          loginForm.get('password')?.touched
                            ? 'touched-password'
                            : invalidCred 
                            ? 'invalid-credentials'
                            : ''
                        ]">Confirm Password
                    </label>
                  </span>
                  <div class="error-msg-container">
                    <div 
                        id="password-err-msg" 
                        class="error-msg error-msg-cant"
                        *ngIf="loginForm.get('newPassword')?.valid && loginForm.errors?.['passwordMismatch'] && loginForm.get('confirmPassword')?.touched">
                      Passwords do not match.
                    </div>
                    <div 
                      id="password-err-msg" 
                      *ngIf="
                        !loginForm.get('newPassword')?.valid &&
                        loginForm.get('newPassword')?.touched
                      " class="error-msg error-msg-cant">
                        <span [ngClass]="[
                              !loginForm.get('newPassword')?.valid &&
                              loginForm.get('newPassword')?.touched
                                ? 'visible-element'
                                : 'hidden-element'
                            ]">Password is required</span>
                    </div>
                  </div>
                </div>
                <span id="sign-in-id" class="btn-actions" [ngClass]="[
                      loginForm.valid ? 'enable-signin' : 'disable-signin'
                    ]" type="submit" (click)="changePassword()">
                  <span *ngIf="!isLoading">Change Password</span>
                  <span class="sign-btn-load" *ngIf="isLoading">
                    <p-progressSpinner class="signin-spinner" [style]="{ height: '20px', width: '20px' }" strokeWidth="7"
                      animationDuration="0.5s">
                    </p-progressSpinner>
                  </span>
                </span>
              </form>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="app-download-link-container" *ngIf="currentTab !== 'change'">
        <div class="are-you-student-title">
          <span>Are you a student ?</span>
        </div>
        <div class="download-app">
          <span>Download our app from</span>
        </div>

        <div class="app-links">
          <img class="app-download-link" [src]="appStoreIcon" alt="Google Play" (click)="openLink(appStoreLink)"/>
          <img class="app-download-link" [src]="playStoreIcon" alt="Google Play" (click)="openLink(playStoreLink)"/>
        </div>
      </div>
    </div>
    <div class="banner-container">
      <div class="side-container-image"  [ngStyle]="{'background-image': 'url(' + defaultLoginBackground + ')'}">
      </div>
    </div>
  </div>
</div>

<div *ngIf="isLoadingPage" class="loading-cnt">
<span class="loading-cnt">
  Loading...
</span>
</div>